import React from 'react';
import {Avatar, Tooltip} from '@mui/material';
import EditCloneDeleteMenu from "../../Menus/EditCloneDeleteMenu";



export const ProfileGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },
    {
        field: 'paticipations',
        headerName: '',
        description: '',
        sortable: false,
        width: 25,
        renderCell: (profiles) => {
            if (profiles.row.participations > 0) {
                // if(filteredCDP.row.mockIndicator==='f'){
                return (
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"This profile is on a participations contract(s)"}>
                        <Avatar
                            // onClick={() => handleExploreCDPVF(filteredCDP.row.id, filteredCDP.row)}
                            sx={{height: 20, width: 20, fontSize: 16, bgcolor: "rgb(30,144,255)"}}>Pa</Avatar>
                        {/*sx={{ height:20, width: 20, fontSize: 16, bgcolor: teal[500] }}>{filteredCDP.row.mockIndicator} </Avatar>*/}
                    </Tooltip>)
            }
            else {return(<p></p>)}
        }

    },
    {
        field: 'residuals',
        headerName: '',
        description: '',
        sortable: false,
        width: 25,
        renderCell: (profiles) => {
            if (profiles.row.residuals > 0) {
                return (
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"This profile is on a residuals contract(s)"}>
                        <Avatar
                            sx={{height: 23, width: 23, fontSize: 14, bgcolor: "rgb(30,144,255)"}}>Re</Avatar>
                    </Tooltip>)
            }
            else {return(<p></p>)}
        }
    },
    {
        field: 'royalties',
        headerName: '',
        description: '',
        sortable: false,
        width: 25,
        renderCell: (profiles) => {
            if (profiles.row.royalties > 0) {
                return (
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"This profile is on a royalties contract(s)"}>
                        <Avatar
                            sx={{height: 20, width: 20, fontSize: 16, bgcolor: "rgb(30,144,255)"}}>Ro</Avatar>
                    </Tooltip>)
            }
            else {return(<p></p>)}
        }
    },
    {    field: 'id',
        headerName: 'ID',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 60,
    },
    {
        field: 'externalId',
        headerName: 'External Id',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 100,
    },
    {
        field: 'firstName',
        headerName: 'First',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'lastName',
        headerName: 'Last',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'ssn',
        headerName: 'SSN',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'dateOfBirth',
        headerName: 'Born On',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'dateOfDeath',
        headerName: 'Died On',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'companyName',
        headerName: 'Company',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 250,
    },
    {
        field: 'fein',
        headerName: 'FEIN',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'dateOfDissolution',
        headerName: 'Dissolved On',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'streetAddress',
        headerName: 'Street Address',
        sortable: true,
        width: 250,
    },
    {
        field: 'city',
        headerName: 'City',
        sortable: true,
        width: 150,
    },
    {
        field: 'stateProvince',
        headerName: 'State/Province',
        sortable: true,
        width: 150,
    },
    {
        field: 'postalCode',
        headerName: 'Postal Code',
        sortable: true,
        width: 150,
    },
    {
        field: 'country',
        headerName: 'Country',
        sortable: true,
        width: 250,
    },
    {
        field: 'paymentSystem',
        headerName: 'Payment System',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'payStatus',
        headerName: 'Pay Status',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'status',
        headerName: 'Status',
        sortable: true,
        width: 150,
    },
];
